import { useSelector } from 'react-redux';

import { Anchor, Text } from '@zillow/constellation-10';

import { RootState } from '../../../../../store/types';

const ContactLandlordSection = () => {
  const { name, email } = useSelector((state: RootState) => state.payments.renter.dashboard.landlordProfile);
  return (
    <Text className="fs-exclude">
      {name}&nbsp;
      <Anchor href={`mailto:${email}`}>Contact</Anchor>
    </Text>
  );
};

export default ContactLandlordSection;
